import React from "react";
import defaultImageSrc from "../../Utility/images/startup.webp";

export type StartupRecognitionProps = {
  imageSrc?: string;
  imageAlt?: string;
  id?: string;
  className?: string;
};

const StartupRecognition: React.FC<StartupRecognitionProps> = ({
  imageSrc = defaultImageSrc,
  imageAlt = "Recognition graphic",
  id = "startup-recognition",
  className = "",
}) => {
  return (
    <section
      id={id}
      aria-label="Startup India recognition"
      className={[
        "relative isolate overflow-hidden",
        "py-4 sm:py-4 lg:py-6", // reduced padding
        "bg-gradient-to-b from-white via-slate-50 to-white dark:from-slate-900 dark:via-slate-900/60 dark:to-slate-900",
        className,
      ].join(" ")}
    >
      {/* Decorative blobs */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 -top-16 -z-10 flex justify-center opacity-50 blur-2xl"
      >
        <div className="h-32 w-[24rem] rounded-full bg-gradient-to-tr from-indigo-300 via-fuchsia-300 to-emerald-300 dark:from-indigo-500/30 dark:via-fuchsia-500/30 dark:to-emerald-500/30" />
      </div>

      <div className="container mx-auto max-w-2xl px-3">
        {/* Card */}
        <div style={{backgroundColor:'white'}} className="relative rounded-2xl border border-slate-200/70 bg-white/90 p-3 shadow-md ring-1 ring-black/5 backdrop-blur-md dark:border-slate-700/50 dark:bg-slate-900/70">
          {/* Badge */}
          <div className="mb-2 flex items-center justify-center gap-2">
            <span className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[10px] font-medium text-slate-700 shadow-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200">
              <span className="text-sm">✨</span>
              Recognised Startup — DPIIT
            </span>
          </div>

          {/* Main text */}
          <h2 className="mx-auto max-w-2xl text-center text-lg font-semibold tracking-tight text-slate-900 sm:text-xl dark:text-white">
            <span className="bg-gradient-to-r from-indigo-600 via-fuchsia-600 to-emerald-600 bg-clip-text text-transparent">
              Proudly recognised under Startup India by DPIIT
            </span>
          </h2>
          <p style={{color:'black'}} className="mx-auto mt-2 max-w-2xl text-center text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            Affirming our commitment to simplifying operations for growing businesses.
          </p>

          {/* Divider */}
          <div className="mx-auto my-3 h-px w-16 rounded bg-gradient-to-r from-indigo-500 via-fuchsia-500 to-emerald-500" />

          {/* Image below the text */}
          <div className="mx-auto flex max-w-52 justify-center">
            <img
              src={imageSrc}
              alt={"Startup recognition"}
              className="h-auto w-full max-w-md rounded-xl border border-slate-200 shadow-sm ring-1 ring-black/5 transition-transform duration-300 hover:scale-[1.01] dark:border-slate-700"
              loading="lazy"
            />
          </div>

          {/* Subtle footer note */}
          <div style={{color:'black'}} className="mt-3 text-center text-[11px] text-slate-500 dark:text-slate-400">
            Registered with DPIIT — Startup India
          </div>
        </div>
      </div>

      {/* Bottom gradient glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 -bottom-16 -z-10 flex justify-center opacity-50 blur-2xl"
      >
        <div className="h-32 w-[24rem] rounded-full bg-gradient-to-tr from-emerald-300 via-fuchsia-300 to-indigo-300 dark:from-emerald-500/30 dark:via-fuchsia-500/30 dark:to-indigo-500/30" />
      </div>
    </section>
  );
};

export default StartupRecognition;
